module.exports = __webpack_public_path__ + "img/inherit-icon.26848095.svg";